<style>
  #LoanChart span,
  #LoanChart svg{
    position: relative;
    width: 100% !important;
    height: auto !important;
    max-height: 400px;
  }

  #LoanChart svg > g[class*="raphael-group-"] > text{
    display: none !important;
  }

  #LoanChart svg > g:first-of-type > g:first-child{
    opacity: 0;
  }
</style>

<template>
    <div id="LoanChart">
      <fusioncharts
        :type="type"
        :width="width"
        :height="height"
        :dataformat="dataFormat"
        :dataSource="dataSource"
      />
    </div>
</template>

<script>
  import Vue from 'vue';
  import {yearData, monthData} from './loan-data';
  import VueFusionChartsComponent from 'vue-fusioncharts/component';

  import FusionCharts from 'fusioncharts';
  import Charts from 'fusioncharts/fusioncharts.powercharts';

  const vueFusionCharts = VueFusionChartsComponent(FusionCharts, Charts);

  Vue.component('fusioncharts', vueFusionCharts);

  export default {
    name: 'loangraph',
    props: {
      data: Array,
      timeFrame: String
    },
    created(){
      setTimeout(() => {
        const svg = this.$el.querySelector("svg");
        if(svg)
          svg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
      }, 200);
    },
    data() {
      return {
        type: "mscolumn2d",
        width: "550",
        height: "383",
        dataFormat: "json"
      }
    },
    computed: {
      dataSource: function(){
        return {
          "month": monthData,
          "year": yearData
        }[this.timeFrame]
      }
    }
  }
</script>
